module.exports = __webpack_public_path__ + "img/photo-1-1.edc4047a.webp";